declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription, timer } from 'rxjs';
import { routerTransition } from '../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbModalOptions, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
import { CounsellingPlanController, SaveCounsellingPlanRequest, LabSpecimenCollectionController, LabSpecimenCollectionRequest, LabOrderDetailsController, LabOrderDetailsRequest, LabOrderTestsController, LabOrderTestsRequest, SaveSpecimenCollectionInfoRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, LabOrderResultsController, LabOrderResultsRequest, LabOrderResultsByTestController, LabOrderResultsByTestRequest, SaveTestResultsInfoRequest, ResultItems, SaveResultStatusInfoRequest, UpdateTestResultStatus, GenericProcPostRequest, S_Methods, LabOrderTestResultsController, GetLabOrderTestResultsRequest } from '../../../../../src/app/ncs/models/actor/actor';
import { CounsellingPlanRequest } from '../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../src/app/ncs/services/actor.service';
//import { NgbSearchPatientModal } from './modal/searchpatient.modal';
//import { NgbEditCounsellingPlanModal } from './modal/editcounsellingplan.modal';
import { NGXToastrService } from '../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSpecimenCollection } from './specimencollection.modal';
import { Script } from 'vm';
import { PrintService } from '../../services/print.service';
const isNullOrUndefined = (val: any) => val === null || val === undefined;
@Component({
  selector: 'resultsentry',
  templateUrl: './resultsentry.component.html',
  styleUrls: ['./resultsentry.component.css'],

})
export class ResultsEntryComponent implements OnInit {

  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: string;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public ShowMonitoring: boolean = false;
  public ShowCounselling: boolean = true;
  public Showarrow: boolean = false;
  public isRequesting: boolean = false;
  public Laborder: any;
  public candisplayspe: boolean = false;
  public BranchName: any;
  public isvisible: boolean = true;
  public PatientFormttedCode: any;
  DOB: NgbDateStruct;
  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  public date: Date;
  public date2: Date;
  searchTitle: string;
  public Selectedtoday: any;
  public SelectedDuration: any;
  public SelectedFromDate: any;
  public SelectedFromDatenew: NgbDateStruct;
  public SelectedToDatenew: NgbDateStruct;
  public SelectedToDate: any;
  public SelectedDepCode: any;
  public isdisplaydate: any;
  public SelectedFacilityCode: any;
  public Comments: string;
  public LaborderTestCode: any;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentEditSaveSpecimenCollectionInfoRequest: SaveSpecimenCollectionInfoRequest;

  sub: Subscription;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentSaveTestResultsInfoRequest: SaveTestResultsInfoRequest;
  CurrentSaveResultStatusInfoRequest: SaveResultStatusInfoRequest;

  CanSign1(SelectedTestDetails: any): boolean {
    var td: LabOrderTestsController = SelectedTestDetails as LabOrderTestsController;

    // how can it be null?? => Should never be false at this level
    if (td == null) return false;

    if (td.OrderTestStatus == "Results Pending") {
      // results are not entered, cannot sign.
      return false;
    }

    if (td.OrderTestStatus == "Results Entered") {
      // results are entered,can sign now.
      return true;
    }

    // has second sign??
    if (td.HasSecondSign != null) {
      // yes
      if (td.HasSecondSign) {
        // is second sign complete?
        if (!isNullOrUndefined(td.SecondSign) && td.SecondSignCode > 0) {
          // it means, already first sign completed..
          return false; // both signs completed
        }
        else {
          return true; // first may or may not happen.
        }
      }
    }
    else {
      // no second sign , hence check only first sign      
      // is first sign complete?
      if (!isNullOrUndefined(td.FirstSign) && td.FirstSignCode > 0) {
        // it means, already first sign completed..
        return false;
      }
      else {
        // 1st sign not complete
        return true;//  no sign happend
      }
    }
  }
  CanSign2(SelectedTestDetails: any): boolean {
    return (SelectedTestDetails.HasFirstSign && SelectedTestDetails.HasSecondSign) &&
      (SelectedTestDetails.FirstSignCode != null && SelectedTestDetails.SecondSignCode == null) &&
      SelectedTestDetails.OrderTestStatus == 'Resutls Entered';

    }
  CanSign3(SelectedTestDetails: any): boolean {

    return (SelectedTestDetails.HasFirstSign && !SelectedTestDetails.HasSecondSign)
      && SelectedTestDetails.FirstSignCode == null && SelectedTestDetails.OrderTestStatus == 'Resutls Entered';
  }
  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentLabSpecimenCollectionController: LabSpecimenCollectionController[];
  CurrentLabSpecimenCollectionRequest: LabSpecimenCollectionRequest;
  //CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  //CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadCounselling() {
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabSpecimenCollectionRequest = new LabSpecimenCollectionRequest();
    this.CurrentLabSpecimenCollectionRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabSpecimenCollectionRequest.LabOrderCode = this.Laborder;
    this.CurrentLabSpecimenCollectionRequest.ConditionalOperator = 10;
    this.GetLabSpecimenCollectionController();
  }

  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetLabSpecimenCollectionController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetLabSpecimenCollectionController(this.CurrentLabSpecimenCollectionRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentLabSpecimenCollectionController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  Age: number;
  CurrentLabOrderDetailsController: LabOrderDetailsController[];
  Laborderdata: LabOrderDetailsController;
  CurrentLabOrderDetailsRequest: LabOrderDetailsRequest;
  //CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  //CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadOrders() {
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderDetailsRequest = new LabOrderDetailsRequest();
    this.CurrentLabOrderDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderDetailsRequest.ConditionalOperator = 10;
    this.CurrentLabOrderDetailsRequest.LabOrderCode = this.Laborder;
    this.GetLabOrderDetailsController();
  }

  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetLabOrderDetailsController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetLabOrderDetailsController(this.CurrentLabOrderDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentLabOrderDetailsController = this.ApiResData.Result;
          this.Laborderdata = this.CurrentLabOrderDetailsController[0];
          this.Age = this.CurrentLabOrderDetailsController[0].AgeYears;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentLabOrderTestsController: LabOrderTestsController[];
  LabDepartments: LabOrderTestsController[];
  CurrentLabOrderTestsRequest: LabOrderTestsRequest;
  //CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  //CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadTests() {
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderTestsRequest = new LabOrderTestsRequest();
    this.CurrentLabOrderTestsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderTestsRequest.ConditionalOperator = 10;
    this.CurrentLabOrderTestsRequest.LabOrderCode = this.Laborder;
    this.CurrentLabOrderTestsRequest.UserCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.GetLabOrderTestsController();
  }

  
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetLabOrderTestsController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetLabOrderTestsController(this.CurrentLabOrderTestsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentLabOrderTestsController = this.ApiResData.Result;
          if (!isNullOrUndefined(this.lastSignedTest)) {

            var test = this.CurrentLabOrderTestsController.filter(x => x.OrderTestCode == this.lastSignedTest)[0];
            this.SelectedTestDetails = test; //.OrderTestStatus = test.OrderTestStatus;
            this.SelectedTest_(this.SelectedTestDetails, false);
            this.lastSignedTest = null;
          }        


          var filterArray = this.CurrentLabOrderTestsController.reduce((accumalator, current) => {
            if (!accumalator.some(item => item.LabDepartmentName === current.LabDepartmentName)) {


              accumalator.push(current);
            }
            return accumalator;
          }, []);
          this.LabDepartments = filterArray;
          // this.Laborderdata = this.CurrentLabOrderDetailsController[0];
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    public printService: PrintService,
    private loaderService: SpinnerService,
    private spinner: NgxSpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private tosterservice: NGXToastrService,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter) { }

  ngOnInit() {
    this.spinner.hide();
    $.getScript('./healins-assets/js/tree.js');
    this.Laborder = this.route.snapshot.paramMap.get('Laborder');
    this.LaborderTestCode = this.route.snapshot.paramMap.get('LaborderTestCode');
    this.BranchName = this.route.snapshot.paramMap.get('BranchName'); 
    this.PatientFormttedCode = this.route.snapshot.paramMap.get('PatientFormttedCode');
    this.Selectedtoday = this.route.snapshot.paramMap.get('Selectedtoday');
    this.SelectedDuration = this.route.snapshot.paramMap.get('SelectedDuration');
    this.SelectedFromDate = this.route.snapshot.paramMap.get('SelectedFromDate');
    this.date = new Date(this.SelectedFromDate);
    this.SelectedFromDatenew = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() };
    this.SelectedToDate = this.route.snapshot.paramMap.get('SelectedToDate');
    this.date2 = new Date(this.SelectedToDate);
    this.SelectedToDatenew = { year: this.date2.getFullYear(), month: this.date2.getMonth() + 1, day: this.date2.getDate() };
    this.SelectedDepCode = this.route.snapshot.paramMap.get('SelectedDepCode');
    this.isdisplaydate = this.route.snapshot.paramMap.get('isdisplaydate');
    this.SelectedFacilityCode = this.route.snapshot.paramMap.get('SelectedFacilityCode');
    this.CurrentEditSaveSpecimenCollectionInfoRequest = new SaveSpecimenCollectionInfoRequest();
    this.CurrentEditSaveSpecimenCollectionInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveTestResultsInfoRequest = new SaveTestResultsInfoRequest();
    this.CurrentSaveTestResultsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveResultStatusInfoRequest = new SaveResultStatusInfoRequest();
    this.CurrentSaveResultStatusInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //alert(this.Laborder);
    this.LoadPatients(this.PatientFormttedCode);
    this.LoadCounselling();
    this.LoadOrders();
    this.LoadTests();
    this.CurrentUpdateTestResultStatus = new UpdateTestResultStatus();
    this.CurrentUpdateTestResultStatus.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    // this.CurrentDeleteCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentDeleteCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



  ShowList: boolean = true;




  BackToCounselling() {
    this.ShowCounselling = true;
    this.ShowMonitoring = false;
    this.Showarrow = false;
  }
  //SelectedPlan: CounsellingPlanController;
  //  edit(l: CounsellingPlanController) {

  //  this.CurrentEditCounsellingPlanRequest.Concerns = l.Concerns;
  //  this.CurrentEditCounsellingPlanRequest.ActorCode = l.ActorCode.toString();
  //  this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = l.CounsellingDoctor;
  //    this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = l.CounsellingPlanCode;
  //    this.CurrentEditCounsellingPlanRequest.BranchCode = l.BranchCode;
  //  this.CurrentEditCounsellingPlanRequest.FinancialStatus = l.FinancialStatus;
  //  this.CurrentEditCounsellingPlanRequest.PackageCost = l.PackageCost;
  //  this.CurrentEditCounsellingPlanRequest.PlanStatus = l.PlanStatus;
  //  this.CurrentEditCounsellingPlanRequest.Potential = l.Potential;
  //  this.CurrentEditCounsellingPlanRequest.RecommendedPackage = l.RecommendedPackage;
  //  this.CurrentEditCounsellingPlanRequest.SelectEmi = l.SelectEmi;
  //    this.CurrentEditCounsellingPlanRequest.TreatmentPlan = l.TreatmentPlan;

  //  this.CurrentEditCounsellingPlanRequest.VisitCode = l.VisitCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.EndDate = l.EndDate;
  //    this.CurrentEditCounsellingPlanRequest.ActorCode = l.ActorCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.StartDate = l.StartDate;
  //    this.CurrentEditCounsellingPlanRequest.BranchCode = l.BranchCode;

  //  const modalRef = this.modalService.open(NgbEditCounsellingPlanModal,
  //  {
  //      centered: true,
  //      size: "lg"
  //    })
  //    modalRef.componentInstance.CurrentEditCounsellingPlanRequest = this.CurrentEditCounsellingPlanRequest;
  //    modalRef.componentInstance.FormattedCode = l.FormattedCode;
  //    modalRef.componentInstance.FacilityShortName = l.FacilityShortName;

  //  modalRef.result.then(x => { this.GetCounsellingPlanController() })
  //}




  ///////////
  //edit(objCategory: any) {
  //  var patient: CounsellingPlanController = objCategory;
  //  if (patient != null) {
  //    this.SelectedPlan = patient;
  //    let options: NgbModalOptions = {
  //      centered: true,
  //      size: "lg"
  //    };
  //    const modalRef = this.modalService.open(NgbEditCounsellingPlanModal, options)
  //    modalRef.componentInstance.FormattedCode = patient.FormattedCode;
  //    this.CurrentEditCounsellingPlanRequest.Concerns = patient.Concerns;
  //    this.CurrentEditCounsellingPlanRequest.ActorCode = patient.ActorCode.toString();
  // this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = patient.CounsellingDoctor;
  //  this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = patient.CounsellingPlanCode;
  //    this.CurrentEditCounsellingPlanRequest.FinancialStatus = patient .FinancialStatus;
  //    this.CurrentEditCounsellingPlanRequest.PackageCost = patient.PackageCost;
  //    this.CurrentEditCounsellingPlanRequest.PlanStatus = patient.PlanStatus;
  //    this.CurrentEditCounsellingPlanRequest.Potential = patient.Potential;
  //    this.CurrentEditCounsellingPlanRequest.RecommendedPackage = patient.RecommendedPackage;
  //    this.CurrentEditCounsellingPlanRequest.SelectEmi = patient.SelectEmi;
  //    this.CurrentEditCounsellingPlanRequest.StartDate = patient.StartDate;
  //    this.CurrentEditCounsellingPlanRequest.TreatmentPlan = patient.TreatmentPlan;
  //    this.CurrentEditCounsellingPlanRequest.VisitCode = patient.VisitCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.EndDate = patient.EndDate;

  //  }
  //}
  onSubmit2(e) {
    if (e.target.checked) {
      var canTests = this.CurrentLabOrderTestsController.find(x => { return x.IsSelected == true; });

      if (canTests == null) {

        this.candisplayspe = false;
      }
      else {
        this.candisplayspe = true;
      }


    }
    else if (!e.target.checked) {
      var canTests = this.CurrentLabOrderTestsController.find(x => { return x.IsSelected == true; });

      if (canTests == null) {

        this.candisplayspe = false;
      }
      else {
        this.candisplayspe = true;
      }
    }

  }
  //SpecimenDetails(l: LabOrderTestsController) {

  //  const modalRef = this.modalService.open(NgbSpecimenCollection,
  //    {
  //      centered: true,
  //      size: "lg"

  //    })
  //  modalRef.componentInstance.PatientName = this.Laborderdata.PatientName;
  //  modalRef.componentInstance.Gender = this.Laborderdata.Gender;
  //  modalRef.componentInstance.Age = this.Age;
  //  modalRef.componentInstance.PatientFormttedCode = this.PatientFormttedCode;
  //  modalRef.componentInstance.Phonenumber = this.Laborderdata.Telephone1;
  //  modalRef.componentInstance.OrderId = this.LabSpecimens[0].LabOrderFormattedCode;
  //  modalRef.componentInstance.Branch = this.Laborderdata.FacilityName;
  //  modalRef.componentInstance.OrderDate = this.Laborderdata.EffectiveOrderDate;
  //  modalRef.componentInstance.SelectedTests = this.CurrentLabOrderTestsController.filter(
  //    function (a) {
  //      return a.IsSelected == true
  //    });
  //  modalRef.componentInstance.OrderCode = this.Laborderdata.LabOrderCode;
  //  modalRef.componentInstance.BranchCode = this.Laborderdata.Branch;
  //  modalRef.componentInstance.PatientCode = this.Laborderdata.PatientID;
  //  modalRef.componentInstance.Specimen = this.LabSpecimens[0].Specimen;
  //  modalRef.componentInstance.Mode = "Add";
  //  modalRef.result.then(x => { this.GetLabSpecimenCollectionController() })
  //}
  //SpecimenDetails2(l: LabSpecimenCollectionController) {

  //    this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionVolume = Number(l.SpecimenCollectionAmount);
  //    this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionDate = l.RecievedOn;
  //    this.CurrentEditSaveSpecimenCollectionInfoRequest.TestMethod = l.CollectionMethod;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.DOC = Number(l.DOC);  
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1 = l.GestationAge1;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1Units = l.GestationAge1Units;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2 = l.GestationAge2;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2Units = l.GestationAge2Units;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.Comments = l.Comments;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionTime = l.SpecimenCollectionTime;
  //  this.CurrentEditSaveSpecimenCollectionInfoRequest.OrderTestSpecimenCollectionCode = l.OrderTestSpecimenCollectionCode;
  //  const modalRef = this.modalService.open(NgbSpecimenCollection,
  //    {
  //      centered: true,
  //      size: "lg"

  //    })
  //  modalRef.componentInstance.PatientName = this.Laborderdata.PatientName;
  //  modalRef.componentInstance.Gender = this.Laborderdata.Gender;
  //  modalRef.componentInstance.Age = this.Age;
  //  modalRef.componentInstance.PatientFormttedCode = this.PatientFormttedCode;
  //  modalRef.componentInstance.Phonenumber = this.Laborderdata.Telephone1;
  //  modalRef.componentInstance.OrderId = this.LabSpecimens[0].LabOrderFormattedCode;
  //  modalRef.componentInstance.Branch = this.Laborderdata.FacilityName;
  //  modalRef.componentInstance.OrderDate = this.Laborderdata.EffectiveOrderDate;
  //  modalRef.componentInstance.Tests = l.TestsName;
  //  modalRef.componentInstance.OrderCode = this.Laborderdata.LabOrderCode;
  //  modalRef.componentInstance.BranchCode = this.Laborderdata.Branch;
  //  modalRef.componentInstance.PatientCode = this.Laborderdata.PatientID;
  //  modalRef.componentInstance.Specimen = this.LabSpecimens[0].Specimen;
  //  modalRef.componentInstance.Mode = "Edit";
  //  modalRef.componentInstance.CurrentEditSaveSpecimenCollectionInfoRequest = this.CurrentEditSaveSpecimenCollectionInfoRequest;
  //  modalRef.result.then(x => { this.GetLabSpecimenCollectionController() })
  //}
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
    this.spinner.hide();
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
    this.spinner.show();
  }

  Selectedpatient: CounsellingPlanController;
  Open(objCategory: any) {
    var patient: CounsellingPlanController = objCategory;
    if (patient != null) {
      this.Selectedpatient = patient;
      this.ShowMonitoring = true;
      this.ShowCounselling = false;
      this.Showarrow = true;
    }
    else {
      this.Selectedpatient = null;
    }
  }
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {

    this.router.navigate(['testnurse/profileview']);
  }
  GetTests(LabDep: string) {
    if (LabDep != null) {
      var a = this.CurrentLabOrderTestsController.filter(X => X.LabDepartmentName === LabDep)
      return a;
    }
  }
  GetSpecimen(Specimen: string) {
    if (Specimen != null) {
      var a = this.CurrentLabSpecimenCollectionController.filter(X => X.SpecimenCode === Specimen)
      return a;
    }
  }
  TestResultEntry: boolean = false;
  SelectedTestDetails: LabOrderTestsController;
  SelectedTest(objCategory: any) {
    var Patient: LabOrderTestsController = objCategory;
    if (Patient != null) {
      this.SelectedTestDetails = null;
      this.SelectedTestDetails = Patient;
      this.TestResultEntry = true;
      this.LoadResults();
      this.LoadTestResults();
      //alert(this.SelectedTestDetails.SecondSign);
      // this.LoadResults2();
      //this.ngOnChanges2(this.changes);
    }

  }
  SelectedTest_(objCategory: any, refresh: boolean) {
    var Patient: LabOrderTestsController = objCategory;
    if (Patient != null) {
      this.SelectedTestDetails = null;
      this.SelectedTestDetails = Patient;

      //this.TestResultEntry = true;
      //this.LoadResults();
      //this.LoadTestResults();
      
    }

  }
  CurrentLabOrderResultsController: LabOrderResultsController[];
  CurrentLabOrderResultsRequest: LabOrderResultsRequest;
  //CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  //CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadResults() {
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderResultsRequest = new LabOrderResultsRequest();
    this.CurrentLabOrderResultsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderResultsRequest.ConditionalOperator = 10;
    this.CurrentLabOrderResultsRequest.OrderCode = this.Laborder;
    this.CurrentLabOrderResultsRequest.UserCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.GetLabOrderResultsController();
  }

  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetLabOrderResultsController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetLabOrderResultsController(this.CurrentLabOrderResultsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentLabOrderResultsController = this.ApiResData.Result;

          // this.Laborderdata = this.CurrentLabOrderDetailsController[0];
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentLabOrderTestResultsController: LabOrderTestResultsController[];
  ExaminationTypes = [];
  //ExaminationType: LabOrderTestResultsController[];
  LoadTestResults() {
    this.ExaminationTypes = [];
    var getReq = new GetLabOrderTestResultsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101035;
    getReq.OrderCode = this.SelectedTestDetails.LabOrderCode;
    getReq.UserCode = AppData.Instance().UserLoginDetails.ActorCode;
    getReq.OrderTestCode = this.SelectedTestDetails.OrderTestCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101035;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentLabOrderTestResultsController = JSON.parse(data);
          
          this.CurrentLabOrderTestResultsController.forEach(x => {
            var n = this.ExaminationTypes.filter(et => et == x.ExaminationType).length;
            if (n == 0) {
              this.ExaminationTypes.push(x.ExaminationType);
            }            
        });
          
          //var filterArray = this.CurrentLabOrderTestResultsController.reduce((accumalator, current) => {
          //  if (!accumalator.some(item => item.ExaminationType === current.ExaminationType)) {


          //    accumalator.push(current);
          //  }
          //  return accumalator;
          //}, []);
          //this.ExaminationType = filterArray;
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  CurrentLabOrderResultsByTestController: LabOrderResultsByTestController[];
  CurrentLabOrderResultsByTestRequest: LabOrderResultsByTestRequest;
  //CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  //CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadResults2() {
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderResultsByTestRequest = new LabOrderResultsByTestRequest();
    this.CurrentLabOrderResultsByTestRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentLabOrderResultsByTestRequest.ConditionalOperator = 10;
    this.CurrentLabOrderResultsByTestRequest.LabOrderCode = this.Laborder;
    this.CurrentLabOrderResultsByTestRequest.UserCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.GetLabOrderResultsByTestController();
  }

  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetLabOrderResultsByTestController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetLabOrderResultsByTestController(this.CurrentLabOrderResultsByTestRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentLabOrderResultsByTestController = this.ApiResData.Result;

          // this.Laborderdata = this.CurrentLabOrderDetailsController[0];
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  private getResultValue(res: any): number {
    if (res === null || res === undefined) return 0;
    if (typeof res === 'number') return res;
    if (typeof res === 'string') return parseInt(res, 10) || 0;
    if (Array.isArray(res) && res.length > 0) {
      const first = res[0];
      if (typeof first === 'number') return first;
      if (typeof first === 'object' && first !== null) {
        if ('Result' in first && typeof first.Result === 'number') return first.Result;
        if ('Result' in first && typeof first.Result === 'string') return parseInt(first.Result, 10) || 0;
        const keys = Object.keys(first);
        if (keys.length > 0 && typeof first[keys[0]] === 'number') return first[keys[0]];
      }
      return res.length;
    }
    return 0;
  }

  Results() {
    this.isvisible = false;
    this.CurrentSaveTestResultsInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveTestResultsInfoRequest.OrderCode = this.SelectedTestDetails.LabOrderCode;
    this.CurrentSaveTestResultsInfoRequest.OrderTestCode = this.SelectedTestDetails.OrderTestCode;
    this.CurrentSaveTestResultsInfoRequest.Comments = this.SelectedTestDetails.Remarks;
    this.lastSignedTest = this.SelectedTestDetails.OrderTestCode;
    //this.CurrentSaveTestResultsInfoRequest.OriginalTestCode =
    this.CurrentSaveTestResultsInfoRequest.OriginalTestCode =  this.GetDetails(this.SelectedTestDetails.TestName) != null ?
      this.GetDetails(this.SelectedTestDetails.TestName)[0].OriginalTestCode: 0;
    this.CurrentSaveTestResultsInfoRequest.Results = new Array<ResultItems>();
    var a = this.CurrentLabOrderTestResultsController.filter(X => X.TestName === this.SelectedTestDetails.TestName)
    a.forEach((v, i, a) => {
      var item: ResultItems = new ResultItems();
      item.ObservationName = v.ObservationName;
      item.ObservationValue = v.ObservationValue;
      item.OrderTestObservation = v.OrderTestObservation;
      this.CurrentSaveTestResultsInfoRequest.Results.push(item);
    });
    // this.CurrentSaveTestResultsInfoRequest.Results = new Array<ResultItems>;


    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SaveTestResultsInfo(this.CurrentSaveTestResultsInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          const resVal = this.getResultValue(this.ApiResData.Result);
          if (resVal > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = true;
            //this.spinner.hide();
            // this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
            this.LoadTests();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            //this.activeModal.close();
            //this.spinner.hide();
            this.isvisible = true;
            this.stopRefreshing();

          }

        }
        else {
          //this.spinner.hide();
          this.stopRefreshing();
          this.isvisible = true;
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            //this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            // this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            //this.spinner.hide();
            this.isvisible = true;
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            //this.spinner.hide();
            this.isvisible = true;
            this.stopRefreshing();
          }
        }
      );

  }
  CurrentUpdateTestResultStatus: UpdateTestResultStatus;
  lastSignedTest: number;
  Sign1() {
    var saveReq = new UpdateTestResultStatus();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40290;
    saveReq.OrderCode = this.SelectedTestDetails.LabOrderCode;
    saveReq.OrderTestCode = this.SelectedTestDetails.OrderTestCode;
    this.lastSignedTest = this.SelectedTestDetails.OrderTestCode;
   // saveReq.OriginalTestCode = this.GetDetails(this.SelectedTestDetails.TestName)[0].OriginalTestCode;
    saveReq.SignStatus = "Signed";
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40290;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          //this.LoadOrders();
          this.LoadTests();
          //this.LoadResults();
          //this.LoadTestResults();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  UnSign1() {
    var saveReq = new UpdateTestResultStatus();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40300;
    saveReq.OrderCode = this.SelectedTestDetails.LabOrderCode;
    saveReq.OrderTestCode = this.SelectedTestDetails.OrderTestCode;
    this.lastSignedTest = this.SelectedTestDetails.OrderTestCode;
    // saveReq.OriginalTestCode = this.GetDetails(this.SelectedTestDetails.TestName)[0].OriginalTestCode;
    saveReq.SignStatus = "Signed";
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40300;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          //this.LoadOrders();
          this.LoadTests();
          //this.LoadResults();
          //this.LoadTestResults();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  Sign() {
    this.CurrentSaveResultStatusInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveResultStatusInfoRequest.OrderCode = this.SelectedTestDetails.LabOrderCode;
    this.CurrentSaveResultStatusInfoRequest.OrderTestCode = this.SelectedTestDetails.OrderTestCode;
    //this.CurrentSaveResultStatusInfoRequest.OriginalTestCode = this.GetDetails(this.SelectedTestDetails.TestName)[0].OriginalTestCode;
    this.CurrentSaveResultStatusInfoRequest.SignStatus = "Signed";
    // this.CurrentSaveTestResultsInfoRequest.Results = new Array<ResultItems>;


    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SaveResultStatusInfo(this.CurrentSaveResultStatusInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          const resVal = this.getResultValue(this.ApiResData.Result);
          if (resVal > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.spinner.hide();
            // this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            //this.activeModal.close();
            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          //this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            //this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            // this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            //this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            //this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  UnSign() {
    this.CurrentSaveResultStatusInfoRequest.ConditionalOperator = 20;
    this.CurrentSaveResultStatusInfoRequest.OrderCode = this.SelectedTestDetails.LabOrderCode;
    this.CurrentSaveResultStatusInfoRequest.OrderTestCode = this.SelectedTestDetails.OrderTestCode;
    this.CurrentSaveResultStatusInfoRequest.OriginalTestCode = this.GetDetails(this.SelectedTestDetails.TestName)[0].OriginalTestCode;
    this.CurrentSaveResultStatusInfoRequest.SignStatus = "Signed";
    // this.CurrentSaveTestResultsInfoRequest.Results = new Array<ResultItems>;


    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SaveResultStatusInfo(this.CurrentSaveResultStatusInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          const resVal = this.getResultValue(this.ApiResData.Result);
          if (resVal > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.spinner.hide();
            // this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            //this.activeModal.close();
            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          //this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            //this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            // this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            //this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            //this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  BackToProfile() {
    this.router.navigate(['healins/labdas', {
      Selectedtoday: this.Selectedtoday, SelectedDuration: this.SelectedDuration, SelectedFromDate2: new Date(this.parserFormatter.format(this.SelectedFromDatenew)), SelectedToDate: new Date(this.parserFormatter.format(this.SelectedToDatenew)), SelectedDepCode: this.SelectedDepCode, LoadData: "yes", isdisplaydate: this.isdisplaydate, SelectedFacilityCode: Number(this.SelectedFacilityCode)
    }]);
  }
  del_(l: LabSpecimenCollectionController) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(l.OrderTestSpecimenCollectionCode);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(OrderTestCode: number) {



    this.CurrentEditSaveSpecimenCollectionInfoRequest.ConditionalOperator = 30;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.OrderTestSpecimenCollectionCode = OrderTestCode;

    this.actorservice.SaveSpecimenCollectionInfo(this.CurrentEditSaveSpecimenCollectionInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          const resVal = this.getResultValue(this.ApiResData.Result);
          if (resVal > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            // this.LoadOvaryData();

            // this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  Show() {

    var toggler = document.getElementsByClassName("caret");
    var i;
    for (i = 0; i < toggler.length; i++) {
      toggler[i].addEventListener("click", function () {
        this.parentElement.querySelector(".nested").classList.toggle("active");
        this.classList.toggle("caret-down");
      });
    }

  }
  GetDetailsByExaminationType(TestName: string, ExaminationType: string) {
    if (TestName != null) {
      var a = this.CurrentLabOrderTestResultsController.filter(X => X.TestName == TestName && X.ExaminationType == ExaminationType);
        //.sort(x=>x.Se;     
      return a;
    }
    return null;
  }
  GetDetails(TestName: string) {
   // alert(TestName);
    if (TestName != null) {

      var a = this.CurrentLabOrderTestResultsController.filter(X => X.TestName === TestName)
      //var a = this.CurrentLabOrderResultsController.filter(X => X.TestName === TestName)
      return a;
    }
 //   alert("Test Not Found in Results..?");
    return null;
  }
  //AddPlan() {
  //  const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
  //    {
  //      centered: true,
  //      size: 'lg'

  //    })

  //}

  //SearchPatient() {
  //  const modalRef = this.modalService.open(NgbSearchPatientModal,
  //    {
  //      centered: true,
  //      size: 'lg'
  //    })

  //  modalRef.result.then((val: string) => {
  //    //alert(val);
  //    const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
  //      {
  //        centered: true,
  //        size: 'lg'
  //      })
  //    modalRef.componentInstance.FormattedCode = val;
  //    modalRef.result.then(x => { this.GetCounsellingPlanController()})
  //  });

  //}

  //del_(CounsellingPlanCode: any) {

  //  swal({
  //    title: 'Are you sure?',
  //    text: "You won't be able to revert this!",
  //    type: 'warning',
  //    showCancelButton: true,
  //    confirmButtonColor: '#0CC27E',
  //    cancelButtonColor: '#FF586B',
  //    confirmButtonText: 'Yes, delete it!',
  //    cancelButtonText: 'No, cancel!',
  //    confirmButtonClass: 'btn btn-success btn-raised mr-5',
  //    cancelButtonClass: 'btn btn-danger btn-raised',
  //    buttonsStyling: false
  //  }).then(() => {



  //    this.DeleteActorIdentities(CounsellingPlanCode);


  //  }, function (dismiss) {

  //    if (dismiss === 'cancel') {
  //      swal(
  //        'Cancelled',
  //        'Delete Operation Cancelled :)',
  //        'error'
  //      )
  //    }
  //  })
  //}
  tests() {
    //alert("hello");
    this.printService.printDocument2(this.SelectedPatientFormattedCode.FormattedCode, 0

    );
    this.printService.printDocument3(this.SelectedPatientFormattedCode.FormattedCode, 0

    ); 
    this.printService.printDocument("labsample1",
      {
        TestName: this.SelectedTestDetails.TestName,
        PatientId: this.SelectedPatientFormattedCode.FormattedCode,
        LabOrderCode: this.SelectedTestDetails.LabOrderCode,
        OrderTestCode: this.SelectedTestDetails.OrderTestCode,
        DepartmentName: this.SelectedTestDetails.LabDepartmentName,
        EffectiveOrderDate: this.Laborderdata.EffectiveOrderDate,
        FacilityName: this.Laborderdata.FacilityName,
        SpecimenName: this.SelectedTestDetails.Specimen,
        FirstSigningName: this.SelectedTestDetails.FirstSign,
        SecondSigningName: this.SelectedTestDetails.SecondSign,
        Remarks: this.SelectedTestDetails.Remarks,
      },
    );
  }
}
